import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHookstate } from "@hookstate/core";
import {
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { PEOPLE_SERVICES } from "redux/reduxToolkitServices/_commonServices/peopleServices";
import '@progress/kendo-theme-default/dist/all.css';
import {
    ModalTitle,
    ModalButton
} from "pages/People/PeopleStyled";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import PersonIcon from "assets/svgIcons/PeopleSubSideNav/PersonIcon";
import SpecialNeedCarIcon from "assets/svgIcons/CarType/SpecialNeeds";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import FbIcon from "assets/svgIcons/CarType/F&B";
import SquareIcon from "assets/svgIcons/PeopleSubSideNav/SquareIcon";
import SquareCheckIcon from "assets/svgIcons/PeopleSubSideNav/SquareCheckIcon";
import { carType } from "constant";
import PeopleAlertModal from "../peopleAlertModal";

const EditPermissionModal = React.memo(({   setIsLoading,
                                            selectedPermission,
                                            setSelectedPermission,
                                            editPermissionModalOpen,
                                            setEditPermissionModalOpen
    }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [pin, setPin] = useState("");
    const [carTypeButton, setCarTypeButton] = useState(carType.normal);
    const [unlock, setUnlock] = useState(true);
    const [idleRelockRestage, setIdleRelockRestage] = useState(300);
    const [shouldSaveEditButtonBeDisabled, setShouldSaveEditButtonBeDisabled] = useState(true);
    const [openPeopleDiscardChangesModalOpen, setOpenPeopleDiscardChangesModalOpen] = useState(false);
    
    useEffect(() => {
            if(selectedPermission) {
                setPin(selectedPermission.PIN);

                if(selectedPermission.CarType != null)
                    setCarTypeButton(selectedPermission.CarType);

                if(selectedPermission.Unlocks != null)
                    setUnlock(selectedPermission.Unlocks);

                if(selectedPermission.IdleRelockSeconds != null)
                    setIdleRelockRestage(selectedPermission.IdleRelockSeconds);
            }
        }, [selectedPermission]);

    const closeEditPermissionModal = () => {
        setSelectedPermission(null)
        setEditPermissionModalOpen(false);
        setPin("");
        setShouldSaveEditButtonBeDisabled(true);
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const savePermissions = () => {
        let request = {
            RFIDId: selectedPermission.RFIDId,
            TagId: selectedPermission.TagId,
            CarType: carTypeButton,
            Unlocks: unlock,
            IdleRelockSeconds: idleRelockRestage,
            PIN: pin
        };

        dispatch(PEOPLE_SERVICES.updateRfidService(siteId.get(), selectedPermission.RFIDId, request));

        closeEditPermissionModal();
        setIsLoading(true);       
    }

    const openPeopleDiscardChangesModal = () => {
        if(selectedPermission.PIN != pin || 
            selectedPermission.CarType != carTypeButton ||
            selectedPermission.Unlocks != unlock ||
            selectedPermission.IdleRelockSeconds != idleRelockRestage) {
                setOpenPeopleDiscardChangesModalOpen(true);
        } else {
            closeEditPermissionModal();
        }
    }

    const handlePin = (e) => {
        const value = e.target.value;

        // Allow only digits and max 4 characters
        if (/^\d{0,4}$/.test(value)) {
        setPin(value);
        setShouldSaveEditButtonBeDisabled(false);
        }
    }

    const closeAlertModal = () => {
        setOpenPeopleDiscardChangesModalOpen(false);
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: '#ffffff',
        border: '2px solid #ccc',
        boxShadow: 24,
        p: 4,
    }

    const subTitleStyle = {
        fontSize: 20,
        textAlign: "center",
        margin: 20
    }

    const personInputStyle = {
        width: '80%', 
        height: 38, 
        border: 'solid 1px #ccc' 
    }

    const personPinInputStyle = {
        width: '30%', 
        height: 38, 
        border: 'solid 1px #ccc' 
    }

    const fieldParentStyle = {
        margin: 15,
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px'
    }

    const personLabelStyle = {
        width: 90
    }

    const fleetCarTypeStyle = {
        padding: "5px 10px", 
        backgroundColor: carTypeButton == carType.normal ? "var(--theme-background)" : "transparent", 
        border: `2px solid ${carTypeButton == carType.normal ? '#fff' : '#000'}`
    }

    const staffCarTypeStyle = {
        padding: "5px 10px", 
        backgroundColor: carTypeButton == carType.marshal ? "var(--theme-background)" : "transparent", 
        border: `2px solid ${carTypeButton == carType.marshal ? '#fff' : '#000'}`
    }

    const specialNeedsCarTypeStyle = {
        padding: "5px 10px", 
        backgroundColor: carTypeButton == carType.handicap ? "var(--theme-background)" : "transparent", 
        border: `2px solid ${carTypeButton == carType.handicap ? '#fff' : '#000'}`
    }

    const hospitalityCarTypeStyle = {
        padding: "5px 10px", 
        backgroundColor: carTypeButton == carType.bevcart ? "var(--theme-background)" : "transparent", 
        border: `2px solid ${carTypeButton == carType.bevcart ? '#fff' : '#000'}`
    }

    const unlockButtonStyle = {
        backgroundColor: unlock ? "var(--theme-background)" : "white",
        padding: 5, 
        border: unlock ? "1px solid #fff" : "1px solid #000",
        margin: "5px 0px",
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        color:  unlock ? "white" : "black",
        fontSize: 16
    }

    const warningStyle = {
        color: "red"
    }

    return (<>
                <Modal 
                    open={editPermissionModalOpen}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description">
                        <Box sx={modalStyle}>
                            <ModalTitle>
                                <div>{t("Edit_Permission")}</div>

                                <div style={{display: 'flex', justifyContent: 'flex-end', cursor: 'pointer'}} onClick={openPeopleDiscardChangesModal}>
                                    <ModalCloseIcon width={18} height={18} color="#fff" />
                                </div>
                            </ModalTitle> 

                            <div style={subTitleStyle}>{selectedPermission?.FirstName} {selectedPermission?.LastName}</div>

                            <div style={fieldParentStyle}>
                                <label style={personLabelStyle}>{t("Tag_ID")}</label> 
                                <input type='text' disabled value={selectedPermission?.TagId} style={personInputStyle} />
                            </div>

                            <div style={fieldParentStyle}>
                                <label style={personLabelStyle}>{t("PIN")}</label>
                                <input type='number' pattern="\d{4}" style={personPinInputStyle} value={pin} onChange={(e) => handlePin(e)} />
                                {pin != "" && pin?.length < 4 ? <label style={warningStyle}>PIN must be 4 digits</label> : ""}
                            </div>

                            <div style={fieldParentStyle}>
                                <label style={personLabelStyle}>{t("Car_Type")}</label>
                                <button title={t("Fleet")} style={fleetCarTypeStyle}><PersonIcon color={carTypeButton == carType.normal ? '#fff' : '#000'} onClick={() => { setCarTypeButton(carType.normal); setShouldSaveEditButtonBeDisabled(false); }} /></button>
                                <button title={t("Staff_Car")} style={staffCarTypeStyle}><MarshalsCarIcon color={carTypeButton == carType.marshal ? '#fff' : '#000'} onClick={() => { setCarTypeButton(carType.marshal); setShouldSaveEditButtonBeDisabled(false); }} /></button>
                                <button title={t("Special_needs_mode")} style={specialNeedsCarTypeStyle}><SpecialNeedCarIcon bg={carTypeButton == carType.handicap ? '#fff' : '#000'}  onClick={() => { setCarTypeButton(carType.handicap); setShouldSaveEditButtonBeDisabled(false); }} /></button>
                                <button title={t("Hospitality_car")} style={hospitalityCarTypeStyle}><FbIcon color={carTypeButton == carType.bevcart ? '#fff' : '#000'} onClick={() => { setCarTypeButton(carType.bevcart); setShouldSaveEditButtonBeDisabled(false); }} /></button>
                            </div>

                            <div style={fieldParentStyle}>
                                <label style={personLabelStyle}></label>
                                <button onClick={() => { setUnlock(!unlock); setShouldSaveEditButtonBeDisabled(false); }} style={unlockButtonStyle} >                                
                                    {unlock ? <SquareCheckIcon color={ unlock ? "white" : "black"} /> :  <SquareIcon color={ unlock ? "white" : "black"} />} Unlock
                                </button>
                            </div>

                            <div style={fieldParentStyle}>
                                <label style={personLabelStyle}>{t("Idle_Relock_Restage")}</label>
                                <input type='number' style={personInputStyle} value={idleRelockRestage} onChange={(e) => { setIdleRelockRestage(e.target.value); setShouldSaveEditButtonBeDisabled(false); }} /> secs
                            </div>

                            <ModalButton>
                                    <>
                                        <button 
                                            onClick={openPeopleDiscardChangesModal} 
                                            style={{ marginRight: 10, height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc' }}>
                                                {t("Cancel")}
                                        </button>
                                        <button 
                                            disabled={shouldSaveEditButtonBeDisabled}
                                            onClick={savePermissions}
                                            style={shouldSaveEditButtonBeDisabled ? { height: 35, padding: 10,  backgroundColor: '#ccc', color: 'white', border: 'solid 1px #ccc', cursor: "not-allowed	"  } : { height: 35, padding: 10, backgroundColor: '#bc9b6a', color: 'white', border: 'solid 1px #ccc' }}>
                                                {t("Save")}
                                        </button>
                                    </>
                            </ModalButton>
                        </Box>
                </Modal>
                <PeopleAlertModal
                                 openPeopleAlertModalOpen={openPeopleDiscardChangesModalOpen} 
                                 yesCallbackFunction={() => closeEditPermissionModal()}
                                 noCallbackFunction={() => closeAlertModal()}
                                 title={t("Confirm_cancel")}
                                 content={t("Are_You_Sure_You_Want_To_Discard_Changes") + "?"} 
                                 loading={false} />
            </>
    );
});

export default EditPermissionModal;
